<app-image-uploader
[data]="imageConfig"
[bg]="bgcolor"
(images)="buttonImage($event)"
(imageSet) ="buttonImageSet($event)"
 ></app-image-uploader>
